export default "__VITE_ASSET__DXhfn7cI__"